var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"证照借用申请","name":"first"}},[_c('LicenseApplication')],1),_c('el-tab-pane',{attrs:{"label":"证照借用记录","name":"second"}},[(_vm.activeName ==='second' )?_c('BorrowingRecord'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }